export const SHIPPED = 'shipped';
export const SELECTED_GALLERIES = 'selectedGalleries';
export const NOT_SHIPPED = 'notShipped';
export const SORT = 'sort';
export const DIRECTION = 'direction';
export const PAGE = 'page';
export const ORDER_ID = 'orderId';
export const ORDER_FILTER_INPUT_TEST_ID = 'order-filter-input-test-id';
